module.exports = __webpack_public_path__ + "img/2.df019dc8.png";